import React from 'react';
import { HeroContainer } from './hero-styles';

const Hero = ({ children }) => {
	return (
		<React.Fragment>
			<HeroContainer>{children}</HeroContainer>
		</React.Fragment>
	);
};

export default Hero;
